import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, vShow as _vShow, withDirectives as _withDirectives, createVNode as _createVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/paper/clock.png'
import _imports_1 from '@/assets/paper/studentPic.png'


const _withScopeId = n => (_pushScopeId("data-v-10738aa6"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "dvPaper" }
const _hoisted_2 = { class: "dvLeft" }
const _hoisted_3 = { class: "dvLeftQuestion" }
const _hoisted_4 = { class: "dvLeftBottom" }
const _hoisted_5 = { class: "dvButton-Container dvNext" }
const _hoisted_6 = { class: "dvButton-Container dvPrevious" }
const _hoisted_7 = { class: "dvRight" }
const _hoisted_8 = {
  key: 0,
  class: "submit-container"
}
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "timer" }, null, -1))
const _hoisted_10 = {
  key: 1,
  class: "submit-container"
}
const _hoisted_11 = { class: "timer" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "clock"
}, null, -1))
const _hoisted_13 = { class: "countdown-item" }
const _hoisted_14 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_15 = { class: "countdown-item" }
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" : ")
const _hoisted_17 = { class: "countdown-item" }
const _hoisted_18 = { class: "dv-examinee" }
const _hoisted_19 = { class: "dv-examineeInfo" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dv-img" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "img",
    src: _imports_1
  })
], -1))
const _hoisted_21 = { class: "dv-info" }
const _hoisted_22 = { class: "w100 pSchoolInfo" }
const _hoisted_23 = { class: "mgt8 w100 pSchoolInfo" }
const _hoisted_24 = { class: "dv-exam-title" }
const _hoisted_25 = { class: "dv-parts" }
const _hoisted_26 = ["id"]
const _hoisted_27 = { class: "dv-alias" }
const _hoisted_28 = { class: "dv-aliase" }
const _hoisted_29 = { class: "dv-questions" }
const _hoisted_30 = ["id", "onClick"]
const _hoisted_31 = { class: "dv-sp-question" }
const _hoisted_32 = { class: "dvPaperCustomAlert" }
const _hoisted_33 = { class: "mockPaperMask" }
const _hoisted_34 = { class: "mockPaperText" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_choice_question = _resolveComponent("choice-question")!
  const _component_multiple_question = _resolveComponent("multiple-question")!
  const _component_sheet_music_creation = _resolveComponent("sheet-music-creation")!
  const _component_true_or_false_question = _resolveComponent("true-or-false-question")!
  const _component_sheet_music_song = _resolveComponent("sheet-music-song")!
  const _component_sheet_music_sing = _resolveComponent("sheet-music-sing")!
  const _component_connect_question = _resolveComponent("connect-question")!
  const _component_fills_in_question = _resolveComponent("fills-in-question")!
  const _component_brief_answer_question = _resolveComponent("brief-answer-question")!
  const _component_nesting_question = _resolveComponent("nesting-question")!
  const _component_drag_question = _resolveComponent("drag-question")!
  const _component_color_wheel_question = _resolveComponent("color-wheel-question")!
  const _component_jigsaw_question = _resolveComponent("jigsaw-question")!
  const _component_VolumeSetting = _resolveComponent("VolumeSetting")!
  const _component_countdown = _resolveComponent("countdown")!
  const _component_custom_alert = _resolveComponent("custom-alert")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.question.type === 1)
            ? (_openBlock(), _createBlock(_component_choice_question, {
                key: _ctx.question.id,
                ref: "questionRef",
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                onChangePartsAnswer: _ctx.changePartsAnswer
              }, null, 8, ["question", "disabled", "onChangePartsAnswer"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 2)
            ? (_openBlock(), _createBlock(_component_multiple_question, {
                key: _ctx.question.id,
                ref: "questionRef",
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                onChangePartsAnswer: _ctx.changePartsAnswer
              }, null, 8, ["question", "disabled", "onChangePartsAnswer"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 3)
            ? (_openBlock(), _createBlock(_component_sheet_music_creation, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef",
                onError: _ctx.onQuestionCompError
              }, null, 8, ["question", "disabled", "onError"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 4)
            ? (_openBlock(), _createBlock(_component_true_or_false_question, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef",
                onChangePartsAnswer: _ctx.changePartsAnswer
              }, null, 8, ["question", "disabled", "onChangePartsAnswer"]))
            : _createCommentVNode("", true),
          ([5, 6].includes(_ctx.question.type))
            ? (_openBlock(), _createBlock(_component_sheet_music_song, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef",
                onError: _ctx.onQuestionCompError
              }, null, 8, ["question", "disabled", "onError"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 7)
            ? (_openBlock(), _createBlock(_component_sheet_music_sing, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef",
                onError: _ctx.onQuestionCompError
              }, null, 8, ["question", "disabled", "onError"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 8)
            ? (_openBlock(), _createBlock(_component_connect_question, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef"
              }, null, 8, ["question", "disabled"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 9)
            ? (_openBlock(), _createBlock(_component_fills_in_question, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef"
              }, null, 8, ["question", "disabled"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 10)
            ? (_openBlock(), _createBlock(_component_brief_answer_question, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef"
              }, null, 8, ["question", "disabled"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 11)
            ? (_openBlock(), _createBlock(_component_nesting_question, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                onError: _ctx.onQuestionCompError,
                ref: "questionRef"
              }, null, 8, ["question", "disabled", "onError"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 12)
            ? (_openBlock(), _createBlock(_component_drag_question, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef"
              }, null, 8, ["question", "disabled"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 13)
            ? (_openBlock(), _createBlock(_component_color_wheel_question, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef"
              }, null, 8, ["question", "disabled"]))
            : _createCommentVNode("", true),
          (_ctx.question.type === 14)
            ? (_openBlock(), _createBlock(_component_jigsaw_question, {
                key: _ctx.question.id,
                question: _ctx.question,
                disabled: _ctx.questionDisable,
                ref: "questionRef"
              }, null, 8, ["question", "disabled"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("button", {
              style: _normalizeStyle(_ctx.nextBtnStyle),
              class: "dvBtn",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.getNext && _ctx.getNext(...args)))
            }, " 下一题 ", 4)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("button", {
              class: "dvBtn",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.getPrevious && _ctx.getPrevious(...args)))
            }, " 上一题 ", 512), [
              [_vShow, _ctx.btnPreviousShow]
            ])
          ]),
          _createVNode(_component_VolumeSetting, { class: "dvButton-Container" })
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        (_ctx.examType === 'histroy')
          ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
              _hoisted_9,
              _createElementVNode("button", {
                onClick: _cache[2] || (_cache[2] = () => _ctx.goBack())
              }, "返 回")
            ]))
          : (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_countdown, {
                  ref: "countdownRef",
                  time: _ctx.time,
                  format: "HH:mm:ss",
                  onFinish: _ctx.handleFinish
                }, {
                  default: _withCtx(({ resolved }) => [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(resolved.HH), 1),
                    _hoisted_14,
                    _createElementVNode("span", _hoisted_15, _toDisplayString(resolved.mm), 1),
                    _hoisted_16,
                    _createElementVNode("span", _hoisted_17, _toDisplayString(resolved.ss), 1)
                  ]),
                  _: 1
                }, 8, ["time", "onFinish"])
              ]),
              _createElementVNode("button", {
                onClick: _cache[3] || (_cache[3] = () => _ctx.submitPapers())
              }, "交 卷")
            ])),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _hoisted_20,
            _createElementVNode("div", _hoisted_21, [
              _createElementVNode("div", _hoisted_22, "姓 名：" + _toDisplayString(_ctx.name), 1),
              _createElementVNode("div", _hoisted_23, " 班 级：" + _toDisplayString(_ctx.grade) + _toDisplayString(_ctx.classNumber), 1)
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.examInfo.name), 1),
        _createElementVNode("div", _hoisted_25, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.alias, (aliase, indexPart) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "dv-part",
              id: aliase.id,
              key: aliase.id,
              style: _normalizeStyle({
            marginTop: indexPart === 0 ? '0' : '17px',
          })
            }, [
              _createElementVNode("div", _hoisted_27, [
                _createElementVNode("div", _hoisted_28, _toDisplayString(aliase.alias_name) + " (共" + _toDisplayString(aliase.questions.length) + "题" + _toDisplayString(parseInt(aliase.score)) + "分) ", 1)
              ]),
              _createElementVNode("div", _hoisted_29, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(aliase.questions, (question, indexQuestion) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "dv-question",
                    id: 'question' + question.id,
                    key: question.id,
                    style: _normalizeStyle({
                // backgroundColor: isHasAnswer(question) ? '#dff1e4' : '#1ac36e',
                // color: isHasAnswer(question) ? '#1ac36e' : '#f7f7f7',
                backgroundColor: _ctx.isHasAnswer(question),
                color: _ctx.isHasAnswerColor(question),
                border:
                  indexPart + 1 === _ctx.indexInPart &&
                  indexQuestion + 1 === _ctx.indexInQuestion
                    ? 'solid 5px #ffc13c'
                    : 'solid 5px #f7f7f7',
              }),
                    onClick: ($event: any) => (_ctx.handlePartOrQuestion(indexPart, indexQuestion))
                  }, [
                    _createElementVNode("div", _hoisted_31, _toDisplayString(indexQuestion + 1), 1)
                  ], 12, _hoisted_30))
                }), 128))
              ])
            ], 12, _hoisted_26))
          }), 128))
        ])
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_32, [
        _createVNode(_component_custom_alert, {
          ref: "customAlertRef",
          alertInfo: _ctx.alertInfo
        }, null, 8, ["alertInfo"])
      ], 512), [
        [_vShow, _ctx.showCustomAlert]
      ])
    ]),
    (_ctx.mockPaperLoading == true)
      ? (_openBlock(), _createBlock(_Teleport, {
          key: 0,
          to: "body"
        }, [
          _createElementVNode("div", _hoisted_33, [
            _createElementVNode("div", _hoisted_34, _toDisplayString(_ctx.mockPaperText), 1)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}